<template>
  <a
    class="help-link"
    :class="{ 'help-link--labelled': label }"
    :href="href"
    target="_blank"
    rel="noopener"
    :title="tooltip"
    :aria-label="tooltip"
    @click.stop
  >
    <i class="bi bi-question-circle" aria-hidden="true"></i>
    <span v-if="label" class="help-link__label">{{ label }}</span>
  </a>
</template>

<script>
export default {
  name: 'HelpLink',
  props: {
    topic: { type: String, required: true },
    section: { type: String, default: '' },
    label: { type: String, default: '' },
    title: { type: String, default: 'Learn more' },
  },
  computed: {
    href() {
      return this.$router.resolve({
        name: 'HelpCenter',
        params: { slug: this.topic },
        hash: this.section ? `#${this.section}` : '',
      }).href;
    },
    tooltip() {
      return `${this.title} (opens help in a new tab)`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

.help-link {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  margin-left: 0.35rem;
  color: rgba($primary-color, 0.65);
  font-size: 0.95em;
  line-height: 1;
  text-decoration: none;
  vertical-align: middle;
  border-radius: 999px;
  transition: color 0.15s ease;

  &:hover,
  &:focus-visible {
    color: $primary-color;
  }

  &:focus-visible {
    outline: 2px solid rgba($primary-color, 0.4);
    outline-offset: 2px;
  }
}

.help-link__label {
  font-size: 0.85rem;
  font-weight: 500;
  text-decoration: underline;
  text-underline-offset: 2px;
}
</style>
